module.exports = __webpack_public_path__ + "img/dsc-0070@2x.777cd258.png";